import { Modal } from '@uchi/dino-modal';
import { useState } from 'react';
import useClickStreamEvent from 'utils/clickstream/useClickStreamEvent';
import { AuthModalProps } from '../AuthModal/AuthModal.types';
import styles from './AuthModalV3.module.css';
import AuthFullScreenModalContent from './components/AuthFullScreenModalContent/AuthFullScreenModalContent';
import AuthServiceModalContent from './components/AuthServiceModalContent/AuthServiceModalContent';

type Props = {
  version: 'fullscreen' | 'service';
  handleClose: () => void;
  entryPoint: AuthModalProps['entryPoint'];
};

const AuthModalV3 = ({ version, handleClose, entryPoint }: Props) => {
  const { sendEvent } = useClickStreamEvent();

  const [unsuccessfulAuth, setUnsuccessfulAuth] = useState(false);

  const closeModalBtnHandler = () => {
    if (unsuccessfulAuth) {
      sendEvent({
        eventType: 'click',
        eventInfo: `otvety_close_after_unsuccessful_${version}`,
        customDimentions: {
          cd1: JSON.stringify({ source: entryPoint }),
        },
      });
      setUnsuccessfulAuth(false);
    }
    handleClose();
  };

  //ab1
  if (version === 'fullscreen') {
    return (
      <Modal
        type="service"
        fullScreen={true}
        wrapperClassName={styles.modal_wrapper}
        modalClassName={styles.modal_inner}
        onClose={handleClose}
      >
        <AuthFullScreenModalContent
          handleClose={closeModalBtnHandler}
          setUnsuccessfulAuth={setUnsuccessfulAuth}
          unsuccessfulAuth={unsuccessfulAuth}
          entryPoint={entryPoint}
        />
      </Modal>
    );
  }

  //ab2
  if (version === 'service') {
    return (
      <Modal
        type="service"
        fullScreen={false}
        wrapperClassName={styles.modal_wrapper}
        modalClassName={styles.modal_inner_default}
        onClose={handleClose}
      >
        <AuthServiceModalContent
          handleClose={closeModalBtnHandler}
          setUnsuccessfulAuth={setUnsuccessfulAuth}
          unsuccessfulAuth={unsuccessfulAuth}
          entryPoint={entryPoint}
        />
      </Modal>
    );
  }

  console.error('Invalid prop');
  return null;
};

export default AuthModalV3;
